import React from 'react';

import { Container } from '@mui/material';
import cn from 'classnames';


import HeaderWithIcon from 'components/HeaderWithIcon';
import { HeaderIcon } from 'components/HeaderWithIcon/headerIcons';
import { Heading } from 'components/Headings';

import TopNavigation from 'containers/TopNavigation';

import './style.scss';

interface IProps {
  alignTop?: boolean;
  backLink?: string;
  buttons?: Array<React.ReactNode>;
  icon: HeaderIcon;
  subtitle: Heading;
  title: Heading;
}

const PageWithIcon = ({
  alignTop = false,
  backLink,
  buttons = [],
  icon,
  subtitle,
  title,
}: IProps) => {
  return (
    <Container maxWidth="sm">
      <div className="PageWithIcon">
        {backLink && <TopNavigation backLink={backLink} />}
        <div
          className={cn('PageWithIcon__header', {
            'PageWithIcon__header--top': alignTop,
          })}
        >
          <HeaderWithIcon
            icon={icon}
            title={title}
            subtitle={subtitle}
            headingConfig={{ subtitleAlignCenter: true }}
          />
        </div>

        {buttons.length > 0 && (
          <div
            data-testid="page-with-icons-buttons"
            className={cn('PageWithIcon__buttons', {
              'PageWithIcon__buttons--top': alignTop,
            })}
          >
            {buttons?.map((button) => button)}
          </div>
        )}
      </div>
    </Container>
  );
};

export default PageWithIcon;
